import { Component, OnInit } from '@angular/core';
import { LeaseDetailService } from "@modules/private/lease/data/services/view/lease-detail.service";
import { ApiLeaseService } from '../../data/services/api/api-lease.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-lease-legal',
  templateUrl: './lease-legal.component.html',
  styleUrls: ['./lease-legal.component.scss'],
  providers: [MessageService]
})
export class LeaseLegalComponent implements OnInit {
  constructor(
    public leaseDetailService: LeaseDetailService,
    private apiLeaseService: ApiLeaseService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.populateForm()
  }

  populateForm() {
    const data = this.leaseDetailService.data as any
    if (data) {
      // Optional chaining: los leases viejos no traen la sección `legal`.
      this.leaseDetailService.entityLegal.patchValue({
        file: data.legal?.file || '',
        score: data.legal?.score ?? null,
        notes: data.legal?.notes || ''
      });
    }
  }

  get e() {
    return this.leaseDetailService.entityLegal
  }

  get data() {
    return this.leaseDetailService.data as any
  }

  /** Hay dictamen registrado cuando existe un documento adjunto. */
  isRegistered(): boolean {
    return !!this.data?.legal?.file
  }

  /**
   * Al subir el archivo solo se actualiza el FormControl (no se auto-guarda):
   * el guardado se hace con "Guardar" cuando el form es válido (file + score 1-100).
   */
  onFileSelected(fileUrl: string): void {
    this.leaseDetailService.entityLegal.patchValue({ file: fileUrl });
  }

  onFileDeleted(): void {
    this.leaseDetailService.entityLegal.patchValue({ file: '' });
  }

  onDownloadRequested(fileUrl: string): void {
    this.apiLeaseService.downloadDocumentByUrl(fileUrl).subscribe({
      next: (blob) => {
        if (!blob || blob.size === 0) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'El archivo descargado está vacío. Intente de nuevo.' });
          return;
        }
        const extension = fileUrl.includes('.') ? fileUrl.substring(fileUrl.lastIndexOf('.')) : '';
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'dictamen_legal' + extension;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.messageService.add({ severity: 'success', summary: 'Descarga', detail: 'Archivo descargado correctamente.' });
      },
      error: (error) => {
        console.error('Error al descargar archivo:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudo descargar el archivo.' });
      }
    });
  }

  /**
   * Persiste el dictamen legal completo. El payload envía siempre el objeto
   * `legal` completo, de modo que el lease viejo (sin `legal`) lo obtiene al
   * guardar por primera vez sin romper nada.
   */
  save(): void {
    if (this.e.invalid) {
      this.e.markAllAsTouched();
      return;
    }

    const legalData = {
      legal: {
        file: this.e.value.file,
        score: this.e.value.score,
        notes: this.e.value.notes
      }
    };

    this.apiLeaseService.putCollection(legalData, undefined, 'leases/' + this.leaseDetailService.id)
      .subscribe((response) => {
        if (!response.error) {
          this.leaseDetailService.getLeaseDetail();
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Dictamen legal actualizado correctamente.' });
        }
      });
  }
}
